import { gameConfig } from './config'

/**
 * Цвета ракетки и волана. Корт и сетка в скины не входят — они общие, и
 * пастельная сине-голубая гамма держится ими.
 */
export interface SkinColors {
  frame: string
  frameAccent: string
  string: string
  shaft: string
  grip: string
  gripDark: string
  cap: string
  cork: string
  corkShade: string
  corkBand: string
  feather: string
  featherShade: string
  featherShaft: string
  thread: string
}

export interface Skin {
  id: SkinId
  name: string
  /** Лучший счёт, с которого скин доступен. */
  unlockAt: number
  colors: SkinColors
}

export type SkinId = 'classic' | 'sky' | 'night' | 'pearl'

const classic: SkinColors = {
  frame: '#2d4467',
  frameAccent: '#a9c8ec',
  string: 'rgba(255, 255, 255, 0.8)',
  shaft: '#3a4557',
  grip: '#9fc0e6',
  gripDark: '#7aa2d2',
  cap: '#2d4467',
  cork: '#fbfaf6',
  corkShade: '#d9d4c8',
  corkBand: '#4a78b5',
  feather: '#ffffff',
  featherShade: '#d6dde6',
  featherShaft: 'rgba(120, 135, 155, 0.75)',
  thread: '#6f9ad0',
}

export const skins: readonly Skin[] = [
  { id: 'classic', name: 'Классика', unlockAt: 0, colors: classic },
  {
    id: 'sky',
    name: 'Небо',
    unlockAt: gameConfig.unlocks.sky,
    colors: {
      ...classic,
      frame: '#5b9ad8',
      frameAccent: '#ffffff',
      grip: '#2d4467',
      gripDark: '#1f3150',
      cap: '#5b9ad8',
      corkBand: '#8cc4f0',
      thread: '#5b9ad8',
    },
  },
  {
    id: 'night',
    name: 'Ночь',
    unlockAt: gameConfig.unlocks.night,
    colors: {
      ...classic,
      frame: '#283a73',
      frameAccent: '#b9b3e6',
      string: 'rgba(220, 215, 255, 0.85)',
      grip: '#b9b3e6',
      gripDark: '#9189cf',
      cap: '#283a73',
      corkBand: '#6f64c8',
      featherShade: '#d5d2ee',
      thread: '#8f86d8',
    },
  },
  {
    id: 'pearl',
    name: 'Жемчуг',
    unlockAt: gameConfig.unlocks.pearl,
    colors: {
      ...classic,
      frame: '#eef3f9',
      frameAccent: '#7fa8d8',
      string: 'rgba(61, 110, 168, 0.55)',
      shaft: '#c9d6e4',
      grip: '#ffffff',
      gripDark: '#cfe0f3',
      // Не #7fa8d8: это цвет корта, конус на нём пропадал бы.
      cap: '#3d6ea8',
      cork: '#ffffff',
      corkBand: '#d9e6f5',
      featherShade: '#e4ecf6',
      thread: '#b8cde6',
    },
  },
]

export const defaultSkin: Skin = skins[0]

export function isUnlocked(skin: Skin, best: number): boolean {
  return best >= skin.unlockAt
}

/** Скин по id; неизвестный или ещё закрытый — классика. */
export function resolveSkin(id: string | null, best: number): Skin {
  const skin = skins.find((s) => s.id === id)
  return skin && isUnlocked(skin, best) ? skin : defaultSkin
}

/** Скины, которые открылись, когда рекорд вырос с before до after. */
export function newlyUnlocked(before: number, after: number): Skin[] {
  return skins.filter((s) => s.unlockAt > before && s.unlockAt <= after)
}
